/** @module Apparel/PriceList/ChangePriceListConfigController */
define([
    "dojo/_base/declare",
    "csi/action/Controller"
], function(declare,ActionController) {

    return declare(ActionController, {
        
        /**
         * Replace "Save" with "Save Changes" button
         * @param {View} defView
         * @param {Action[]} defActions
         */
        addProxyActions: function(defView, defActions) {
            defActions.addAction(this.getProxyAction("BUTTON_ChangePriceListConfig", false, {m_bSubmit: true}));
            this.inherited(arguments);
        }
 
    });
});